<template lang="pug">
    div(:class="{ 'relative': $storyblok.isEditing }")
        div(class="flex flex-wrap items-center font-bold")
            span(class="mr-2") Tags:
            BaseButton(
                v-for="tag in tags"
                :key="tag"
                :to="buildUrl(tag)"
                size="XSMALL"
                color="GRAY"
                buttonStyle="OUTLINE"
                class="text-sm normal-case px-4 py-3 mr-3 mb-1"
            ) {{tag}}

        //- Shade for storyblok editor to prevent clicks
        div(
            v-if="$storyblok.isEditing"
            class="absolute inset-0 z-50"
        )
</template>

<script>
import BaseButton from '@/components/baseButton'

export default {
    name: 'TagsWidget',
    components: {
        BaseButton,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        tags() {
            if (!this.$store.getters['content/story']) return
            // Filter out the 'blog' tag from the results
            const tags = this.$store.getters['content/story'].tag_list
            return tags.filter((tag) => tag.toLowerCase() !== 'blog')
        },
    },
    methods: {
        buildUrl(tag) {
            const url = tag
                .toLowerCase()
                .replace(/[^a-zA-Z0-9]/g, '-') // replace all non-alphanumeric characters with dashes
                .replace(/-+/g, '-') // replace consecutive dashes with a single dash
                .replace(/(^-|-$)/g, '') // remove dashes from start and end of string

            return `/blog/${url}`
        },
    },
}
</script>
